import {Injectable, signal} from '@angular/core';
import {Sorting, SelectableItem} from '@brunata-angular/ui';
import {ResidentsFilterData} from './components/residents-filter.component';

export type ResidentsListSnapshot = {
    buildingNo: string;
    filter: ResidentsFilterData;
    sorting: Sorting;
    page: number;
    pageSize: number;
    showPast: boolean;
    showFuture: boolean;
    expandedLocationIds: ReadonlySet<string>;
    onlineAccessOptions: SelectableItem[];
};

@Injectable({providedIn: 'root'})
export class ResidentsListStateService {
    private readonly snapshot = signal<ResidentsListSnapshot | null>(null);

    get(buildingNo: string): ResidentsListSnapshot | null {
        const current = this.snapshot();
        return current?.buildingNo === buildingNo ? current : null;
    }

    save(snapshot: ResidentsListSnapshot): void {
        this.snapshot.set(snapshot);
    }
}
